import React from "react";
import "./environmental-effects.css";

export type WeatherType = "none" | "clouds" | "rain" | "snow";

interface EnvironmentalEffectsProps {
  weather: WeatherType;
  className?: string;
}

export const EnvironmentalEffects: React.FC<EnvironmentalEffectsProps> = ({
  weather,
  className,
}) => {
  if (weather === "none") return null;

  return (
    <div className={`env-container ${className}`}>
      {weather === "clouds" && (
        <div className="env-clouds-container">
          <div className="cloud-layer layer-1" />
          <div className="cloud-layer layer-2" />
        </div>
      )}
      {weather === "rain" && (
        <div className="env-rain-container opacity-30">
          <div className="rain-layer layer-1" />
          <div className="rain-layer layer-2" />
          <div className="rain-layer layer-3" />
          <div className="rain-splash-layer layer-1 hidden" />
          <div className="rain-splash-layer layer-2 hidden" />
        </div>
      )}
      {weather === "snow" && (
        <div className="env-snow-container">
          <div className="snow-layer layer-1" />
          <div className="snow-layer layer-2" />
          <div className="snow-layer layer-3" />
        </div>
      )}
    </div>
  );
};
